module.exports = __webpack_public_path__ + "img/fun06.6127515b.png";